import { ChartType } from "../enums/chart-type";

export const ChartTypeList = {
    [ChartType.AREA] : {
        label: "Basic Area",
        value: ChartType.AREA,
        imageSrc: "/assets/images/preview/area.jpg"
    },
    [ChartType.AREA_SPLINE] : {
        label: "Area-spline",
        value: ChartType.AREA_SPLINE,
        imageSrc: "/assets/images/preview/area-spline.jpg"
    } ,
    [ChartType.BAR] : {
        label: "Basic bar",
        value: ChartType.BAR,
        imageSrc: "/assets/images/preview/bar.jpg.jpg"
    },
    [ChartType.LINE] : {
        label: "Basic line",
        value: ChartType.LINE,
        imageSrc: "/assets/images/preview/line.jpg"
    } 
} as const